import { render } from "./UserChip.vue?vue&type=template&id=4bd27d26"
import script from "./UserChip.vue?vue&type=script&lang=js"
export * from "./UserChip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__